export const paths = {
  homePage: "/",
  chatRoom: "/room",
  api: "/api",
};
